import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/app/store/authStore';

interface ModuleGuardProps {
  module: string;
  children: React.ReactNode;
}

export const ModuleGuard: React.FC<ModuleGuardProps> = ({ module, children }) => {
  const currentOrganization = useAuthStore((s) => s.currentOrganization);
  const isPlatformAdmin = useAuthStore((s) => s.isPlatformAdmin);

  // If there's no organization selected (e.g. platform admin view), we might not have modules.
  // We can let platform admins through if they are viewing platform routes, but this guard is for tenant routes.
  if (isPlatformAdmin && !currentOrganization) {
    return <>{children}</>;
  }

  const enabledModules = currentOrganization?.enabled_modules || [];

  if (!enabledModules.includes(module)) {
    if (module === 'dashboard') {
      const fallbackPath = enabledModules.length > 0 ? `/${enabledModules[0]}` : '/forbidden';
      // Basic heuristic: 'documents' usually maps to '/documents', etc.
      // If we want a safe fallback, '/forbidden' or first module path.
      // Let's just fallback to '/documents' if allowed, else '/forbidden'
      if (enabledModules.includes('documents')) {
        return <Navigate to="/documents" replace />;
      }
      return <Navigate to="/forbidden" replace />;
    }
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
